import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

const { FiTarget, FiShield, FiLayers, FiCpu } = FiIcons;

const ValuePillars = () => {
  const { t } = useLanguage();
  const icons = [FiTarget, FiShield, FiLayers, FiCpu];

  return (
    <section className="py-24 px-6 bg-zinc-900">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {t.pillars.items.map((pillar, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group"
            >
              <div className="flex items-start gap-6">
                <div className="w-14 h-14 shrink-0 bg-zinc-950 border border-white/10 rounded-2xl flex items-center justify-center group-hover:border-orange-500/50 transition-colors">
                  <SafeIcon icon={icons[index]} className="text-2xl text-orange-500" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white mb-3 tracking-tight">{pillar.title}</h3>
                  <p className="text-zinc-400 leading-relaxed text-lg">{pillar.desc}</p>
                  
                  {/* Hub Link - Injected below AI & Automation description */}
                  {index === 3 && (
                    <Link to="/ai-lead-agent" className="text-orange-500 hover:text-orange-400 text-sm font-semibold mt-3 inline-block transition-colors">
                      {t.hub.aiAutomation}
                    </Link>
                  )}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuePillars;